import { render, staticRenderFns } from "./Ubications.vue?vue&type=template&id=6101273a&"
import script from "./Ubications.vue?vue&type=script&lang=js&"
export * from "./Ubications.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports